import React, {Fragment, Component} from "react";
import {
  queryReducer,
  Pagination,
  changeListParams as changeListParamsAction,
  translate
} from "admin-on-rest";
import restClient from "../restClient";
import {parse, stringify} from "query-string";
import {createSelector} from "reselect";
import {connect} from "react-redux";
import {push as pushAction} from "react-router-redux";
import get from "lodash.get";
import {crudGetManyAccumulate as crudGetManyAccumulateAction} from "admin-on-rest";

const getReferencesByIds = (state, reference, ids) => {
  if (ids.length === 0) return {};
  return ids
    .map(id => state.admin.resources[reference].data[id])
    .filter(r => typeof r !== "undefined")
    .reduce((prev, record) => {
      prev[record.id] = record; // eslint-disable-line no-param-reassign
      return prev;
    }, {});
};

class ReferenceArrayInput extends Component {
  state = {
    records: null,
    total: null,
    page: 1,
    perPage: 10,
    sort: {field: "name", order: "ASC"}
  };

  componentDidMount() {
    const {page, perPage, sort} = this.state;
    const {reference} = this.props;
    const pagination = {page: page, perPage: perPage};
    this.getRecords(pagination, sort, reference);
  }

  componentDidUpdate(nextProps) {
    if (nextProps.ids !== this.props.ids) {
      const {page, perPage, sort} = this.state;
      const {reference} = this.props;
      const pagination = {page: page, perPage: perPage};
      this.getRecords(pagination, sort, reference);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.resource !== this.props.resource ||
      nextProps.query.sort !== this.props.query.sort ||
      nextProps.query.order !== this.props.query.order ||
      nextProps.query.page !== this.props.query.page ||
      nextProps.query.filter !== this.props.query.filter
    ) {
      this.updateData(
        Object.keys(nextProps.query).length > 0
          ? nextProps.query
          : nextProps.params
      );
    }
    if (nextProps.version !== this.props.version) {
      this.updateData();
    }
  }

  getBasePath() {
    return this.props.location.pathname.replace(/\/$/, "");
  }

  getRecords(pagination, sort, reference, filter = {id: this.props.ids}) {
    if (this.props.ids.length > 0) {
      restClient("GET_LIST", reference, {
        pagination: {...pagination},
        sort: sort,
        filter: filter
      }).then(({data, total}) => this.setState({records: data, total}));
    }
  }

  updateData(query) {
    const params = query || this.getQuery();
    const {sort, page = 1, perPage, filter} = params;
    const pagination = {
      page: parseInt(page, 10),
      perPage: parseInt(perPage, 10)
    };
    const permanentFilter = this.props.filter;
    this.getRecords(pagination, sort, this.props.reference, {
      ...filter,
      ...permanentFilter
    });
  }

  setPage = page => {
    this.setState({page}, () => {
      this.getRecords({page: page, perPage: 10}, {}, this.props.reference);
    });
  };

  setSort = sort => {
    const order =
      this.state.sort.field === sort.field && this.state.sort.order === "ASC"
        ? "DESC"
        : "ASC";
    this.setState(
      {sort: {field: sort.field, order: order}},
      this.getRecords(
        {page: 1, perPage: 10},
        {field: sort.field, order: order},
        this.props.reference
      )
    );
  };

  setFilters = filters => {
    this.changeParams({type: "SET_FILTER", payload: filters});
  };

  showFilter = (filterName, defaultValue) => {
    this.setState({[filterName]: true});
    if (typeof defaultValue !== "undefined") {
      this.setFilters({
        ...this.props.filterValues,
        [filterName]: defaultValue
      });
    }
  };

  hideFilter = filterName => {
    const removeKey = (target, path) =>
      Object.keys(target).reduce((acc, key) => {
        if (key !== path) {
          return Object.assign({}, acc, {[key]: target[key]});
        }

        return acc;
      }, {});

    const deepRemoveKey = (target, path) => {
      const paths = path.split(".");

      if (paths.length === 1) {
        return removeKey(target, path);
      }

      const deepKey = paths[0];
      const deep = deepRemoveKey(target[deepKey], paths.slice(1).join("."));

      if (Object.keys(deep).length === 0) {
        return removeKey(target, deepKey);
      }

      return Object.assign({}, target, {[deepKey]: deep});
    };

    this.setState({[filterName]: false});

    this.setFilters({id: this.props.ids});
  };

  changeParams(action) {
    const newParams = queryReducer(this.getQuery(), action);
    this.props.push({
      ...this.props.location,
      search: `?${stringify({
        ...newParams,
        filter: JSON.stringify(newParams.filter)
      })}`
    });
    this.props.changeListParams(this.props.resource, newParams);
  }

  getQuery() {
    const query =
      Object.keys(this.props.query).length > 0
        ? this.props.query
        : {...this.props.params};

    if (!query.sort) {
      query.sort = this.state.sort.field;
      query.order = this.state.sort.order;
    }
    if (!query.perPage) {
      query.perPage = this.state.perPage;
    }
    if (!query.page) {
      query.page = 1;
    }
    return query;
  }

  render() {
    const {records, total, perPage, page} = this.state;
    const {children, resource, filters, actions, ...rest} = this.props;

    const query = this.getQuery();
    const filterValues = query.filter;
    const basePath = this.getBasePath();

    return records ? (
      <Fragment>
        <div style={{paddingTop: "0.5em"}}>
          {actions &&
            React.cloneElement(actions, {
              resource,
              filters,
              filterValues,
              basePath,
              displayedFilters: this.state,
              showFilter: this.showFilter
            })}
        </div>
        {filters &&
          React.cloneElement(filters, {
            resource,
            hideFilter: this.hideFilter,
            displayedFilters: this.state,
            filterValues,
            setFilters: this.setFilters,
            context: "form"
          })}

        {React.cloneElement(children, {
          choices: records,
          setSort: this.setSort,
          sort: this.state.sort,
          resource,
          filters,
          basePath,
          actions,
          ...rest
        })}

        <Pagination
          total={total}
          page={parseInt(page, 10)}
          setPage={this.setPage}
          perPage={perPage}
        />
      </Fragment>
    ) : null;
  }
}

ReferenceArrayInput.defaultProps = {
  addField: true,
  filterValues: {},
  addLabel: true
};

const getLocationSearch = props => props.location.search;

const getQuery = createSelector(
  getLocationSearch,
  locationSearch => {
    const query = parse(locationSearch);
    if (query.filter && typeof query.filter === "string") {
      query.filter = JSON.parse(query.filter);
    }
    return query;
  }
);

const emptyIds = [];

function mapStateToProps(state, props) {
  const resourceState = state.admin.resources[props.resource];

  const {record, source, reference} = props;
  const ids = get(record, source) || emptyIds;

  return {
    input: props.input,
    query: getQuery(props),
    params: resourceState.list.params,
    filterValues: resourceState.list.params.filter,
    data: getReferencesByIds(state, reference, ids),
    ids
  };
}

const ConnectedReferenceArrayInput = connect(
  mapStateToProps,
  {
    changeListParams: changeListParamsAction,
    push: pushAction,
    crudGetManyAccumulate: crudGetManyAccumulateAction
  }
)(translate(ReferenceArrayInput));

ConnectedReferenceArrayInput.defaultProps = {
  addField: true,
  filterValues: {},
  addLabel: true
};

export default ConnectedReferenceArrayInput;



// WEBPACK FOOTER //
// ./src/components/ReferenceArrayField.js